import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonUtil, MessageService, TablePage } from '@serengeti/serengeti-common';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class TaskScheduleTemplateService {
	endPoint: string;

	constructor(private messageService: MessageService) {
		this.endPoint = CommonUtil.buildEndPoint(environment.serviceSchedulerEndPoint, 'task/template');
	}

	search(
		filter = '',
		sortItem = 'createdDate', sortOrder = 'asc',
		pageNumber = 1, pageSize = 10): Observable<TablePage> {

		const codeUrl = CommonUtil.buildEndPoint(this.endPoint, '/');

		return this.messageService.query(codeUrl, new HttpParams()
			.set('searchName', filter)
			.set('sortItem', sortItem)
			.set('sortOrder', sortOrder)
			.set('pageNumber', pageNumber.toString())
			.set('pageSize', pageSize.toString())
		).pipe(
			map(res =>  res)
		);
	}

	get(id: string): Observable<any> {
		const codeUrl = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/');

		return this.messageService.query(codeUrl).pipe(
			map(res =>  res)
		);
	}

	save(task: any, id?: string) {
		let taskUrl = CommonUtil.buildEndPoint(this.endPoint, '/');

		if (id) {
			taskUrl += id + '/';
			return this.messageService.put(taskUrl, task);
		} else {
			return this.messageService.post(taskUrl, task);
		}
	}

	delete(id: string) {
		let taskUrl = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/');

		return this.messageService.delete(taskUrl);
	}

}
